/**
 * @generated SignedSource<<1d0c9bc47c7c3bde62a2e7d5704b3c51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PasswordResetDialogMutation$variables = {
  email: string;
};
export type PasswordResetDialogMutation$data = {
  readonly resetPassword: boolean | null | undefined;
};
export type PasswordResetDialogMutation = {
  response: PasswordResetDialogMutation$data;
  variables: PasswordResetDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "kind": "ScalarField",
    "name": "resetPassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordResetDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PasswordResetDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e305a0e4be9d67bde975d43e6c36cba6",
    "id": null,
    "metadata": {},
    "name": "PasswordResetDialogMutation",
    "operationKind": "mutation",
    "text": "mutation PasswordResetDialogMutation(\n  $email: String!\n) {\n  resetPassword(email: $email)\n}\n"
  }
};
})();

(node as any).hash = "747c079bb191defb6c8dedd6063637bc";

export default node;
